import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const user = apiUrl + "/user";
const routes = {
  label: "User",
  root: user,
  get_all: user + "/get_all",
  get_my_colleagues: user + "/get_my_colleagues",
  delete: user + "/delete",
  delete_colleagues: user + "/delete_colleagues",
  update: user + "/update",
  update_colleague: user + "/update_colleague",
  new: user + "/new",
  new_colleague: user + "/new_colleague",
  change_password: user + "/change_password",
  change_colleague_password: user + "/change_colleague_password",
  generate_my_invitation_key: user + "/generate_my_invitation_key",
  get_my_invitation_key: user + "/get_my_invitation_key",
  get_user_type: user + "/get_user_type",
  request_support_access: user + "/request_support_access",
  approve_support_access: user + "/approve_support_access",
};

export const User = {
  label: routes.label,
  new: () => postWithToken(routes.new),
  new_colleague: () => postWithToken(routes.new_colleague),

  update: (user) => postWithToken(routes.update, user),
  update_colleague: (user) => postWithToken(routes.update_colleague, user),

  change_password: (idOrData, password) => {
    if (typeof idOrData === 'object') {
      const data = {
        id: idOrData.id || idOrData.user_id,
        password: idOrData.password || idOrData.new_password
      };
      return postWithToken(routes.change_password, data);
    }
    return postWithToken(routes.change_password, { id: idOrData, password });
  },

  change_colleague_password: (idOrData, password) => {
    if (typeof idOrData === 'object') {
      const data = {
        id: idOrData.id || idOrData.user_id,
        password: idOrData.password || idOrData.new_password
      };
      return postWithToken(routes.change_colleague_password, data);
    }
    return postWithToken(routes.change_colleague_password, { id: idOrData, password });
  },

  get_all: () => postWithToken(routes.get_all),
  get_user_type: () => postWithToken(routes.get_user_type),
  get_my_colleagues: () => postWithToken(routes.get_my_colleagues),

  delete: (ids) => postWithToken(routes.delete, { ids }),
  delete_colleagues: (ids) => postWithToken(routes.delete_colleagues, { ids }),

  generate_my_invitation_key: () => postWithToken(routes.generate_my_invitation_key),
  get_my_invitation_key: () => postWithToken(routes.get_my_invitation_key),
  request_support_access: (target_user_id) => postWithToken(routes.request_support_access, { target_user_id }),
  approve_support_access: (notification_id) => postWithToken(routes.approve_support_access, { notification_id }),
};
